import { Component, OnInit } from '@angular/core';
declare var $: any;
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Chart } from 'chart.js';
import 'chartjs-plugin-labels';

@Component({
  selector: 'app-employee-cnamgs',
  templateUrl: './employee-cnamgs.component.html',
  styleUrls: ['./employee-cnamgs.component.scss']
})
export class EmployeeCnamgsComponent implements OnInit {


  cnamgsList = false;
  page: any;
  response: any;
  cnamgsReportList: any;
  canvas: any;
  ctx: any;
  employeeId:any;
  entity_type:any;
  cnamgsReportListresponse:any;
  reportListcnss:any;
  cnssList:any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private snackBar: MatSnackBar,
    private ngxUiLoaderService: NgxUiLoaderService,
    private api: ApiService, ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.page = this.router.getCurrentNavigation().extras.state.data;
      console.log("26", this.page)
    }
  }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        console.log(params['id']);
        if (params['id']) {
          this.page = params['id'];
        }
      });

      this.route.queryParams.subscribe(params => {
        this.employeeId = params['uuid'];
        this.entity_type = params['entity_type'];
        console.log(this.employeeId, "this.employeeId");
        console.log(this.entity_type, "this.entity_type");
      });
    
    if(this.entity_type && this.employeeId){
      this.getEmployeeListcnamgs();
    }else{
      this.getReports();
    }
  }

  getChartData() {
    if (this.cnamgsReportList && this.cnamgsReportList != null) {
      this.canvas = document.getElementById('balancesheet1');
      if (this.canvas) {
        this.ctx = this.canvas.getContext('2d');
        let profitLossChart = new Chart(this.ctx, {
          type: 'pie',
          data: {
            //labels: [this.incometxt + ' ' + totalincome + ' FCFA', this.expensetxt + ' ' + totalexpense + ' FCFA'],
            datasets: [{
              data: [this.cnamgsReportList.worker, this.cnamgsReportList.employer],
              backgroundColor: [
                "#5d5d5d",
                "#6A8FC2"
              ],
              borderWidth: 1
            }]
          },
          options: {
            responsive: false,
            maintainAspectRatio: false,
            plugins: {
              labels: {
                render: function(args: any) {
                  // args will be something like:
                  // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }
                  //return args.value + ' ' + "FCFA";
                  //return args.label.split(":")[1];
                  return;

                  // return object if it is image
                  // return { src: 'image.png', width: 16, height: 16 };
                },
                fontColor: '#000',
                overlap: true,
                shadowOffsetY: 5
              }
            },
            tooltips: {
              callbacks: {
                label: function(tooltipItem: any, data: any) {
                  console.log(tooltipItem)
                  console.log(data)
                  var label = data.datasets[0].data[tooltipItem.index] || '';
                  if (label) {
                    label += '';
                  }
                  return label;
                }
              }
            }
          }
        });
      }

    }

  }


  goBack() {
    this.location.back();
  }
  showcnamgsList() {
    this.cnamgsList = true;
    $('#reportModal').modal('hide');
  }
  moreDetails(id: any) {
    return;
  }

  getReports() {
    this.ngxUiLoaderService.start();
    this.api.getEmployeeCnamgsReportlist().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.results;
          console.log(res)
          if (res.status == 200) {
            this.cnamgsReportList = this.response
            console.log("50", this.cnamgsReportList)
            setTimeout(() => {
              this.getChartData();
            }, 500)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          console.log("error")
          this.ngxUiLoaderService.stop();
        });
  }


  getEmployeeListcnamgs(){
      var data = {
        entity_type : this.entity_type,
        uuid : this.employeeId
      }
    if(this.entity_type && this.employeeId){
      console.log(data, "details");
    this.ngxUiLoaderService.start();
    this.api.employeeReportList(data).pipe(first()).subscribe(res =>{
    this.ngxUiLoaderService.stop();
    console.log("dataaaasssss", res);
    this.cnamgsReportListresponse = res;
    console.log("this.cnamgsReportListresponse", this.cnamgsReportListresponse);
    if (this.cnamgsReportListresponse.status == 200) {
      this.cnamgsReportList = this.cnamgsReportListresponse.results;
      console.log("this.cnamgsReportList", this.cnamgsReportList);
      setTimeout(() => {
        this.getChartData();
      }, 500);
    }
    }, error => {
      console.log("error")
      this.ngxUiLoaderService.stop();
    })
    }
  }


}
